<template>
  <div :class="['inline-flex max-md:w-[calc(100%-2rem)] w-full racq-max-w-xl3 pl-4 pr-5 py-4 rounded-lg shadow-outer justify-start items-center gap-4', meta.backgroundColour]">
    <div v-if="!!meta.icon" class="self-stretch py-1 flex justify-start items-start gap-2">
        <div class="w-4 h-4 relative">
          <img :src="meta.icon" :alt="`${toastAlert.type} icon`" class="w-4 h-4" />
        </div>
    </div>
    <div class="flex-1 inline-flex flex-col justify-center items-start">
        <div :class="['self-stretch justify-center text-base-bold leading-normal', meta.textColour]">{{ toastAlert.title }}</div>
        <div :class="['self-stretch justify-center text-m leading-tight', meta.textColour]">{{ toastAlert.description }}</div>
    </div>
    <div class="self-stretch py-1 flex justify-start items-start gap-2.5">
        <div data-type="close" class="w-4 h-4 relative">
          <button class="cursor-pointer" @click="onCloseClicked" aria-label="Close toast alert">
            <img :src="meta.closeIcon" alt="close icon" class="w-4 h-4" />
          </button>
        </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IToastAlert } from '@/interfaces/components/toast-alert.interface';
import { ToastAlertMeta } from '@/store/toast-alert/toast-alert.state'

const props = defineProps<{ toastAlert: IToastAlert} >();

type toastAlertEmits = (e: 'close', id: number) => void;
const emit = defineEmits<toastAlertEmits>();
const meta = ToastAlertMeta[props.toastAlert.type];

const onCloseClicked = () => {
  emit('close', props.toastAlert.id);
}
</script>
